import React, { useEffect } from 'react';
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import './MapView.css';
import { Landmark } from '../types';
import LandmarkMarker from './LandmarkMarker';

interface MapViewProps {
  landmarks: Landmark[];
  onLandmarkClick: (landmark: Landmark) => void;
}

// Component to set map view bounds
const MapBounds: React.FC<{ landmarks: Landmark[] }> = ({ landmarks }) => {
  const map = useMap();
  
  React.useEffect(() => {
    if (landmarks.length > 0) {
      // const bounds = landmarks.map(l => [l.position.lat, l.position.lng] as [number, number]);
      // map.fitBounds(bounds, { padding: [50, 50] });
    }
  }, [landmarks, map]);
  
  return null;
};

// Component to handle map resize on mobile - critical for mobile devices
const MapResize: React.FC = () => {
  const map = useMap();
  
  useEffect(() => {
    // Fix for mobile - invalidate size after mount and on resize
    const invalidateSize = () => {
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        map.invalidateSize();
      }, 100);
    };
    
    // Initial resize after mount
    invalidateSize();
    
    // Resize on window events
    window.addEventListener('resize', invalidateSize);
    window.addEventListener('orientationchange', () => {
      // Longer delay for orientation change
      setTimeout(() => {
        map.invalidateSize();
      }, 300);
    });
    
    return () => {
      window.removeEventListener('resize', invalidateSize);
      window.removeEventListener('orientationchange', invalidateSize);
    };
  }, [map]);
  
  return null;
};

const MapView: React.FC<MapViewProps> = ({ landmarks, onLandmarkClick }) => {
  // Center of Abrolhos Islands
  const center: [number, number] = [-28.875023, 113.962863 ];
  const zoom = 9;

  return (
    <div className="map-container">
      <MapContainer
        center={center}
        zoom={zoom}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={true}
      >
        <TileLayer
          attribution='Tiles &copy; Esri &mdash; Source: Esri, Maxar, Earthstar Geographics, and the GIS User Community'
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
        />
        <MapBounds landmarks={landmarks} />
        <MapResize />
        
        {landmarks.map((landmark) => (
          <LandmarkMarker
            key={landmark.id}
            landmark={landmark}
            onClick={() => onLandmarkClick(landmark)}
          />
        ))}
      </MapContainer>
    </div>
  );
};

export default MapView;
